/** @format */

import { sendDustLog as sendDustLogAPI } from './sendLog';

export default class SendLog {
  constructor(data = {}, config) {
    this.config = config;
    this.data = {};
    this.isDataReady = false;
    this.cacheLog = [];
    this.timer = null;
    this.updateData(data, {});
    this.init();
  }

  init() {
    const { globalConfig } = this.config;

    if (!globalConfig.app_id) {
      return;
    }
    this.initLogs();
  }

  updateData(data, customData = {}) {
    this.isDataReady = true;
    this.data = {
      ...customData,
    };
  }

  // 往data里增加数据
  addData(customData) {
    this.data = {
      ...this.data,
      ...customData,
    };
  }

  mapDataToParams(logConfig) {
    const logAfterMap = logConfig;
    const { data } = this;
    Object.keys(logConfig).map(key => {
      let configValue = logConfig[key];
      let value = data[key];
      // 支持config里放入函数
      if (typeof configValue === 'function') {
        value = configValue(value);
      }
      // 如果config里定义了value的值, 则直接使用定义的值
      if (typeof configValue === 'string' && configValue) {
        logAfterMap[key] = configValue;
        return;
      }
      // 配置里有的
      if (value || value === 0 || value === false) {
        logAfterMap[key] = value;
      }
    });
    return logAfterMap;
  }

  sendCacheLog() {
    this.cacheLog.forEach(cb => {
      cb();
    });
    this.cacheLog = [];
  }

  sendLog(cb) {
    if (this.isDataReady) {
      cb();
      this.sendCacheLog();
    } else {
      this.cacheLog.push(cb);
    }
  }

  initLogs() {
    const { apiPath, logs, defaultCommonParams } = this.config;
    Object.keys(logs).forEach(key => {
      this[key] = (params = {}) => {
        const { url = apiPath, event } = logs[key];
        let logConfig = logs[key].params;
        let commonLogParams;
        if (logConfig.commonParams) {
          commonLogParams = this.config[logConfig.commonParams];
        } else if (logConfig.commonParams === '') {
          commonLogParams = {};
        } else {
          commonLogParams = defaultCommonParams;
        }
        // merge config
        logConfig = {
          ...commonLogParams,
          ...logConfig,
        };
        delete logConfig.commonParams;
        // 埋点放在一个函数里，在合适的时机（有app_id)执行
        this.sendLog(() => {
          // map data
          const allParams = {
            ...this.mapDataToParams(logConfig),
            ...params,
          };
          sendDustLogAPI(url, {
            event,
            params: allParams,
          });
        });
      };
    });
  }
}
